export default "__VITE_ASSET__DLbEgZkr__"